<template>
  <div class="centerx pushConfigDetail">
    <vs-prompt
      @cancel="
        active = false
        orderConfigObj = {}
        logisticsConfigObj = {}
        inventoryConfigObj = {}
        orderGodsList = []
        inventryGodsList = []
      "
      buttons-hidden
      :active.sync="active"
      title="推单信息"
    >
      <div class="inner_push_config_dialog">
        <vs-tabs color="rgba(115,103,240,1)">
          <vs-tab label="订单">
            <div class="o_v_auto_rem29">
              <div class="flex flex-wrap flex-row vs-row">
                <div class="p-2">
                  <span>系统唯一序号</span><br />
                  <vs-input
                    placeholder="guid"
                    v-model="orderConfigObj.guid"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>报送类型</span><br />
                  <vs-input
                    placeholder="appType"
                    v-model="orderConfigObj.appType"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>报送时间</span><br />
                  <vs-input
                    placeholder="appTime"
                    v-model="orderConfigObj.appTime"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>业务状态</span><br />
                  <vs-input
                    placeholder="appStatus"
                    v-model="orderConfigObj.appStatus"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>订单类型</span><br />
                  <vs-input
                    placeholder="orderType"
                    v-model="orderConfigObj.orderType"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>订单编号</span><br />
                  <vs-input
                    placeholder="orderNo"
                    v-model="orderConfigObj.orderNo"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>电商平台代码</span><br />
                  <vs-input
                    placeholder="ebpCode"
                    v-model="orderConfigObj.ebpCode"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>电商平台名称</span><br />
                  <vs-input
                    placeholder="ebpName"
                    v-model="orderConfigObj.ebpName"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>电商企业代码</span><br />
                  <vs-input
                    placeholder="ebcCode"
                    v-model="orderConfigObj.ebcCode"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>电商企业名称</span><br />
                  <vs-input
                    placeholder="ebcName"
                    v-model="orderConfigObj.ebcName"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>商品价格</span><br />
                  <vs-input
                    placeholder="goodsValue"
                    v-model="orderConfigObj.goodsValue"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>运杂费</span><br />
                  <vs-input
                    placeholder="freight"
                    v-model="orderConfigObj.freight"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>非现金抵扣金额</span><br />
                  <vs-input
                    placeholder="discount"
                    v-model="orderConfigObj.discount"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>代扣税款</span><br />
                  <vs-input
                    placeholder="taxTotal"
                    v-model="orderConfigObj.taxTotal"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>实际支付金额</span><br />
                  <vs-input
                    placeholder="acturalPaid"
                    v-model="orderConfigObj.acturalPaid"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>币制</span><br />
                  <vs-input
                    placeholder="currency"
                    v-model="orderConfigObj.currency"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人注册号</span><br />
                  <vs-input
                    placeholder="buyerRegNo"
                    v-model="orderConfigObj.buyerRegNo"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人姓名</span><br />
                  <vs-input
                    placeholder="buyerName"
                    v-model="orderConfigObj.buyerName"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人电话</span><br />
                  <vs-input
                    placeholder="buyerTelephone"
                    v-model="orderConfigObj.buyerTelephone"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人证件类型</span><br />
                  <vs-input
                    placeholder="buyerIdType"
                    v-model="orderConfigObj.buyerIdType"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人证件号码</span><br />
                  <vs-input
                    placeholder="buyerIdNumber"
                    v-model="orderConfigObj.buyerIdNumber"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>支付企业代码</span><br />
                  <vs-input
                    placeholder="payCode"
                    v-model="orderConfigObj.payCode"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>支付企业名称</span><br />
                  <vs-input
                    placeholder="payName"
                    v-model="orderConfigObj.payName"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>支付交易编号</span><br />
                  <vs-input
                    placeholder="payTransactionId"
                    v-model="orderConfigObj.payTransactionId"
                    :disabled="stopOrderPush"
                  />
                </div>
                <!-- <div class="p-2">
                  <span>商品批次号:</span><br />
                  <vs-input placeholder="batchNumber" />
                </div> -->
                <div class="p-2">
                  <span>收货人姓名</span><br />
                  <vs-input
                    placeholder="consignee"
                    v-model="orderConfigObj.consignee"
                    :disabled="stopOrderPush"
                  />
                </div>
                <div class="p-2">
                  <span>收货人电话</span><br />
                  <vs-input
                    placeholder="consigneeTelephone"
                    v-model="orderConfigObj.consigneeTelephone"
                    :disabled="stopOrderPush"
                  />
                </div>
                <!-- <div class="p-2">
                  <span>收货人省:</span><br />
                  <vs-input
                    placeholder="consigneeProvince"
                    v-model="orderConfigObj.consigneeProvince"
                  />
                </div>
                <div class="p-2">
                  <span>收货人市:</span><br />
                  <vs-input
                    placeholder="consigneeCity"
                    v-model="orderConfigObj.consigneeCity"
                  />
                </div>
                <div class="p-2">
                  <span>收货人区:</span><br />
                  <vs-input
                    placeholder="consigneeDistrict"
                    v-model="orderConfigObj.consigneeDistrict"
                  />
                </div> -->
                <div class="p-2">
                  <span>收货地址</span><br />
                  <vs-input
                    placeholder="consigneeAddress"
                    v-model="orderConfigObj.consigneeAddress"
                    :disabled="stopOrderPush"
                  />
                </div>

                <!-- <div class="p-2">
                  <span>报文传输模式:</span><br />
                  <vs-input
                    placeholder="dxpMode"
                    v-model="orderConfigObj.dxpMode"
                  />
                </div> -->
              </div>
              <div class="vs-row">
                <div class="vs-col sm:w-1/2 flex lg:flex-row md:flex-no-wrap">
                  <div class="p-2">
                    <span>传输企业名称</span><br />
                    <vs-input
                      placeholder="copName"
                      v-model="orderConfigObj.copName"
                      :disabled="stopOrderPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>传输企业代码</span><br />
                    <vs-input
                      placeholder="copCode"
                      v-model="orderConfigObj.copCode"
                      :disabled="stopOrderPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>报文传输编号</span><br />
                    <vs-input
                      placeholder="dxpId"
                      v-model="orderConfigObj.dxpId"
                      :disabled="stopOrderPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>公服企业名称</span><br />
                    <vs-input
                      placeholder="keyInfo"
                      v-model="orderConfigObj.keyInfo"
                      :disabled="stopOrderPush"
                    />
                  </div>
                </div>
              </div>

              <div
                class="vs-row pt-6 pb-4"
                style="
                  font-weight: 500;
                  font-size: 16px;
                  color: #5e5873;
                  font-family: PingFangSC-Medium;
                "
              >
                订单表体
                <!-- <vs-button
                  class="order-btn-con"
                  @click="orderTableState"
                  style="margin-left: 30px"
                  >{{ orderTable }}</vs-button
                >
                <vs-button
                  type="border"
                  class="order-btn-con"
                  @click="closeOrderTable"
                  v-if="closeOrderTableState"
                  >取消</vs-button
                > -->
              </div>

              <!-- 订单表体编辑按钮 -->
              <!-- <div
                class="vs-row order-btn-right pt-4 pb-6"
                style="margin-top: 0px"
              >
                <vs-button class="order-btn-con" @click="orderTableState">{{
                  orderTable
                }}</vs-button>
                <vs-button
                  type="border"
                  class="order-btn-con"
                  @click="closeOrderTable"
                  v-if="closeOrderTableState"
                  >取消</vs-button
                >
              </div> -->

              <div class="order_goods_push_table">
                <vs-table stripe maxHeight="20" :data="orderGodsList">
                  <template slot="thead">
                    <!-- <vs-th> 编号 </vs-th> -->
                    <vs-th> 商品序号gnum</vs-th>
                    <vs-th> 企业商品名称itemName</vs-th>
                    <vs-th> 商品规格型号gmodel</vs-th>
                    <vs-th> 单位unit</vs-th>
                    <vs-th> 数量count</vs-th>
                    <vs-th> 单价price</vs-th>
                    <vs-th> 总价totalPrice</vs-th>
                    <vs-th> 币制currency</vs-th>
                    <vs-th> 原产国country</vs-th>
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <!-- <vs-td :data="tr.id">
                        {{ tr.id }}
                      </vs-td> -->

                      <!-- <vs-td :data="tr.gnum">
                        {{ tr.gnum }}
                        <template slot="edit">
                          <vs-input
                            v-model="tr.gnum"
                            class="inputx"
                            placeholder="商品序号"
                          />
                        </template>
                      </vs-td> -->

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="gnum"
                          v-model="tr.gnum"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="itemName"
                          v-model="tr.itemName"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="gmodel"
                          v-model="tr.gmodel"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="unit"
                          v-model="tr.unit"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>
                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="count"
                          v-model="tr.count"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="price"
                          v-model="tr.price"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="totalPrice"
                          v-model="tr.totalPrice"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="currency"
                          v-model="tr.currency"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>
                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="country"
                          v-model="tr.country"
                          :disabled="stopOrderPush"
                        />
                      </vs-td>
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <!-- 订单保存按钮 -->
            <div class="order-push-cutline"></div>
            <div class="vs-row order-btn-right p-2">
              <vs-button class="order-btn-con" @click="orderPushState">{{
                orderPush
              }}</vs-button>
              <vs-button
                id="order-cancel1"
                type="border"
                class="order-btn-con"
                @click="closeOrderPush()"
                style="margin-right: 0"
                >{{ orderCancle }}</vs-button
              >
            </div>
          </vs-tab>

          <vs-tab label="清单">
            <!-- 清单推单编辑按钮 -->
            <div class="inventry_goods_push_div">
              <div class="flex flex-wrap flex-row vs-row">
                <div class="p-2">
                  <span>系统唯一序号</span><br />
                  <vs-input
                    placeholder="guid"
                    v-model="inventoryConfigObj.guid"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>报送类型</span><br />
                  <vs-input
                    placeholder="appType"
                    v-model="inventoryConfigObj.appType"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>报送时间</span><br />
                  <vs-input
                    placeholder="appTime"
                    v-model="inventoryConfigObj.appTime"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>业务状态</span><br />
                  <vs-input
                    placeholder="appStatus"
                    v-model="inventoryConfigObj.appStatus"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>订单号</span><br />
                  <vs-input
                    placeholder="orderNo"
                    v-model="inventoryConfigObj.orderNo"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>电商平台代码</span><br />
                  <vs-input
                    placeholder="ebpCode"
                    v-model="inventoryConfigObj.ebpCode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>电商平台名称</span><br />
                  <vs-input
                    placeholder="ebpName"
                    v-model="inventoryConfigObj.ebpName"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>电商企业代码</span><br />
                  <vs-input
                    placeholder="ebcCode"
                    v-model="inventoryConfigObj.ebcCode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>电商企业名称</span><br />
                  <vs-input
                    placeholder="ebcName"
                    v-model="inventoryConfigObj.ebcName"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>物流运单编号</span><br />
                  <vs-input
                    placeholder="logisticsNo"
                    v-model="inventoryConfigObj.logisticsNo"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>物流企业代码</span><br />
                  <vs-input
                    placeholder="logisticsCode"
                    v-model="inventoryConfigObj.logisticsCode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>物流企业名称</span><br />
                  <vs-input
                    placeholder="logisticsName"
                    v-model="inventoryConfigObj.logisticsName"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>企业内部编号</span><br />
                  <vs-input
                    placeholder="copNo"
                    v-model="inventoryConfigObj.copNo"
                    :disabled="stopinventryPush"
                  />
                </div>
                <!-- <div class="p-2">
                  <span>预录入编号:</span><br />
                  <vs-input placeholder="preNo" />
                </div> -->
                <div class="p-2">
                  <span>担保企业编码</span><br />
                  <vs-input
                    placeholder="assureCode"
                    v-model="inventoryConfigObj.assureCode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>账册编号</span><br />
                  <vs-input
                    placeholder="emsNo"
                    v-model="inventoryConfigObj.emsNo"
                    :disabled="stopinventryPush"
                  />
                </div>
                <!-- <div class="p-2">
                  <span>清单编号:</span><br />
                  <vs-input placeholder="invtNo" />
                </div> -->
                <div class="p-2">
                  <span>进出口标记</span><br />
                  <vs-input
                    placeholder="ieFlag"
                    v-model="inventoryConfigObj.ieFlag"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>申报日期</span><br />
                  <vs-input
                    placeholder="declTime"
                    v-model="inventoryConfigObj.declTime"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>申报海关代码</span><br />
                  <vs-input
                    placeholder="customsCode"
                    v-model="inventoryConfigObj.customsCode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>口岸海关代码</span><br />
                  <vs-input
                    placeholder="portCode"
                    v-model="inventoryConfigObj.portCode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>进口日期</span><br />
                  <vs-input
                    placeholder="ieDate"
                    v-model="inventoryConfigObj.ieDate"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人证件类型</span><br />
                  <vs-input
                    placeholder="buyerIdType"
                    v-model="inventoryConfigObj.buyerIdType"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人证件号码</span><br />
                  <vs-input
                    placeholder="buyerIdNumber"
                    v-model="inventoryConfigObj.buyerIdNumber"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人姓名</span><br />
                  <vs-input
                    placeholder="buyerName"
                    v-model="inventoryConfigObj.buyerName"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>订购人电话</span><br />
                  <vs-input
                    placeholder="buyerTelephone"
                    v-model="inventoryConfigObj.buyerTelephone"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>收件地址</span><br />
                  <vs-input
                    placeholder="consigneeAddress"
                    v-model="inventoryConfigObj.consigneeAddress"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>申报企业代码</span><br />
                  <vs-input
                    placeholder="agentCode"
                    v-model="inventoryConfigObj.agentCode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>申报企业名称</span><br />
                  <vs-input
                    placeholder="agentName"
                    v-model="inventoryConfigObj.agentName"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>区内企业代码</span><br />
                  <vs-input
                    placeholder="areaCode"
                    v-model="inventoryConfigObj.areaCode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>区内企业名称</span><br />
                  <vs-input
                    placeholder="areaName"
                    v-model="inventoryConfigObj.areaName"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>贸易方式</span><br />
                  <vs-input
                    placeholder="tradeMode"
                    v-model="inventoryConfigObj.tradeMode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>运输方式</span><br />
                  <vs-input
                    placeholder="trafMode"
                    v-model="inventoryConfigObj.trafMode"
                    :disabled="stopinventryPush"
                  />
                </div>
                <!-- <div class="p-2">
                  <span>运输工具编号:</span><br />
                  <vs-input placeholder="trafNo" />
                </div>
                <div class="p-2">
                  <span>航班航次号:</span><br />
                  <vs-input placeholder="voyageNo" />
                </div>
                <div class="p-2">
                  <span>提运单号:</span><br />
                  <vs-input placeholder="billNo" />
                </div> -->
                <div class="p-2">
                  <span>监管场所代码</span><br />
                  <vs-input
                    placeholder="loctNo"
                    v-model="inventoryConfigObj.loctNo"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>许可证件号</span><br />
                  <vs-input
                    placeholder="licenseNo"
                    v-model="inventoryConfigObj.licenseNo"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>起运国 (地区)</span><br />
                  <vs-input
                    placeholder="country"
                    v-model="inventoryConfigObj.country"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>运费</span><br />
                  <vs-input
                    placeholder="freight"
                    v-model="inventoryConfigObj.freight"
                    :disabled="stopinventryPush"
                  />
                </div>

                <div class="p-2">
                  <span>保费</span><br />
                  <vs-input
                    placeholder="insuredFee"
                    v-model="inventoryConfigObj.insuredFee"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>币制</span><br />
                  <vs-input
                    placeholder="currency"
                    v-model="inventoryConfigObj.currency"
                    :disabled="stopinventryPush"
                  />
                </div>

                <!-- <div class="p-2">
                  <span>报文传输模式:</span><br />
                  <vs-input
                    placeholder="dxpMode"
                    v-model="inventoryConfigObj.dxpMode"
                  />
                </div> -->
                <!-- <div class="p-2">
                  <span>订单类型:</span><br />
                  <vs-input
                    placeholder="orderType"
                    v-model="inventoryConfigObj.orderType"
                  />
                </div> -->

                <!-- <div class="p-2">
                  <span>收货人省:</span><br />
                  <vs-input
                    placeholder="consigneeProvince"
                    v-model="inventoryConfigObj.consigneeProvince"
                  />
                </div>
                <div class="p-2">
                  <span>收货人市:</span><br />
                  <vs-input
                    placeholder="consigneeCity"
                    v-model="inventoryConfigObj.consigneeCity"
                  />
                </div>
                <div class="p-2">
                  <span>收货人区:</span><br />
                  <vs-input
                    placeholder="consigneeDistrict"
                    v-model="inventoryConfigObj.consigneeDistrict"
                  />
                </div> -->
                <div class="p-2">
                  <span>包装种类代码</span><br />
                  <vs-input
                    placeholder="wrapType"
                    v-model="inventoryConfigObj.wrapType"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>件数</span><br />
                  <vs-input
                    placeholder="packNo"
                    v-model="inventoryConfigObj.packNo"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>毛重（公斤）</span><br />
                  <vs-input
                    placeholder="grossWeight"
                    v-model="inventoryConfigObj.grossWeight"
                    :disabled="stopinventryPush"
                  />
                </div>
                <div class="p-2">
                  <span>净重（公斤）</span><br />
                  <vs-input
                    placeholder="netWeight"
                    v-model="inventoryConfigObj.netWeight"
                    :disabled="stopinventryPush"
                  />
                </div>
              </div>
              <!-- <div class="vs-row">
                <div
                  class="vs-col lg:w-4/6 flex lg:flex-row md:flex-no-wrap"
                ></div>
              </div> -->
              <div class="vs-row">
                <div class="vs-col sm:w-1/2 flex lg:flex-row md:flex-no-wrap">
                  <div class="p-2">
                    <span>传输企业名称</span><br />
                    <vs-input
                      placeholder="copName"
                      v-model="inventoryConfigObj.copName"
                      :disabled="stopinventryPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>传输企业代码</span><br />
                    <vs-input
                      placeholder="copCode"
                      v-model="inventoryConfigObj.copCode"
                      :disabled="stopinventryPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>报文传输编号</span><br />
                    <vs-input
                      placeholder="dxpId"
                      v-model="inventoryConfigObj.dxpId"
                      :disabled="stopinventryPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>公服企业名称</span><br />
                    <vs-input
                      placeholder="keyInfo"
                      v-model="inventoryConfigObj.keyInfo"
                      :disabled="stopinventryPush"
                    />
                  </div>
                </div>
              </div>

              <div
                class="vs-row pt-4 pb-6"
                style="
                  font-weight: 500;
                  font-size: 16px;
                  color: #5e5873;
                  font-family: PingFangSC-Medium;
                "
              >
                清单表体
                <!-- <vs-button
                  class="order-btn-con"
                  @click="inventryTableState"
                  style="margin-left: 30px"
                  >{{ inventryTable }}</vs-button
                >
                <vs-button
                color='warning'
                  class="order-btn-con"
                  @click="closeinventryTable"
                  v-if="closeinventryTableState"
                  >取消</vs-button
                > -->
              </div>

              <!-- 清单表体编辑按钮 -->
              <!-- <div
                class="vs-row order-btn-right pt-4 pb-6"
                style="margin-top: 0px"
              >
                <vs-button class="order-btn-con" @click="inventryTableState">{{
                  inventryTable
                }}</vs-button>
                <vs-button
                  type="border"
                  class="order-btn-con"
                  @click="closeinventryTable"
                  v-if="closeinventryTableState"
                  >取消</vs-button
                >
              </div> -->

              <div class="vs-row">
                <vs-table stripe maxHeight="20" :data="inventryGodsList">
                  <template slot="thead">
                    <!-- <vs-th> 编号 </vs-th> -->
                    <vs-th> 商品序号gnum</vs-th>
                    <vs-th> 账册备案号itemRecordNo</vs-th>
                    <vs-th> 商品编码gcode</vs-th>
                    <vs-th> 商品名称itemName</vs-th>
                    <vs-th> 商品规格型号gmodel</vs-th>
                    <vs-th> 原产国(地区)country</vs-th>
                    <vs-th> 币制currency</vs-th>
                    <vs-th> 数量count</vs-th>
                    <vs-th> 法定数量qty1</vs-th>
                    <vs-th> 第二数量qty2</vs-th>
                    <vs-th> 计量单位unit</vs-th>
                    <vs-th> 法定计量单位unit1</vs-th>
                    <vs-th> 第二计量单位unit2</vs-th>
                    <vs-th> 单价price</vs-th>
                    <vs-th> 总价totalPrice</vs-th>
                    <!-- <vs-th> 企业商品货号itemNo </vs-th>
                    <vs-th> 企业商品名称itemName </vs-th>
                    <vs-th> 商品编码gname </vs-th>
                    <vs-th> 条码barCode </vs-th>
                    <vs-th> 贸易国tradeCountry </vs-th>
                    <vs-th> 法定数量2qty2 </vs-th>
                    <vs-th> 第二计量单位unit2 </vs-th>
                    <vs-th> 企业记录名称recordName </vs-th> -->
                  </template>

                  <template slot-scope="{ data }">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <!-- <vs-td :data="tr.id">
                        {{ tr.id }}
                      </vs-td> -->

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="gnum"
                          v-model="tr.gnum"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="itemRecordNo"
                          v-model="tr.itemRecordNo"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>
                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="gcode"
                          v-model="tr.gcode"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="itemName"
                          v-model="tr.itemName"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>
                      <!-- <vs-td :data="tr.itemNo">
                        {{ tr.itemNo }}
                        <template slot="edit">
                          <vs-input
                            v-model="tr.gnum"
                            class="inputx"
                            placeholder="商品序号"
                          />
                        </template>
                      </vs-td> -->
                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="gmodel"
                          v-model="tr.gmodel"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <!-- <vs-td :data="tr.itemName">
                        {{ tr.itemName }}
                        <template slot="edit">
                          <vs-input
                            v-model="tr.itemName"
                            class="inputx"
                            placeholder="企业商品名称"
                          />
                        </template>
                      </vs-td> -->
                      <!-- <vs-td :data="tr.gcode">
                        {{ tr.gcode }}
                        <template slot="edit">
                          <vs-input
                            v-model="tr.gcode"
                            class="inputx"
                            placeholder="商品规格代码"
                          />
                        </template>
                      </vs-td> -->

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="country"
                          v-model="tr.country"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="currency"
                          v-model="tr.currency"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="count"
                          v-model="tr.count"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="qty1"
                          v-model="tr.qty1"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="qty2"
                          v-model="tr.qty2"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="unit"
                          v-model="tr.unit"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="unit1"
                          v-model="tr.unit1"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="unit2"
                          v-model="tr.unit2"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="price"
                          v-model="tr.price"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <vs-td>
                        <vs-input
                          style="width: 100%"
                          placeholder="totalPrice"
                          v-model="tr.totalPrice"
                          :disabled="stopinventryPush"
                        />
                      </vs-td>

                      <!-- <vs-td :data="tr.barCode">
                        {{ tr.barCode }}
                      </vs-td>

                      <vs-td :data="tr.qty2">
                        {{ tr.qty2 }}
                        <template slot="edit">
                          <vs-input
                            v-model="tr.qty2"
                            class="inputx"
                            placeholder="法定数量2"
                          />
                        </template>
                      </vs-td>

                      <vs-td :data="tr.unit2">
                        {{ tr.unit2 }}
                        <template slot="edit">
                          <vs-input
                            v-model="tr.unit2"
                            class="inputx"
                            placeholder="第二计量单位"
                          />
                        </template>
                      </vs-td>
                      <vs-td :data="tr.count">
                        {{ tr.count }}
                        <template slot="edit">
                          <vs-input
                            v-model="tr.count"
                            class="inputx"
                            placeholder="商品数量"
                          />
                        </template>
                      </vs-td>

                      <vs-td :data="tr.itemRecordNo">
                        {{ tr.itemRecordNo }}
                        <template slot="edit">
                          <vs-input
                            v-model="tr.itemRecordNo"
                            class="inputx"
                            placeholder="企业记录名称"
                          />
                        </template>
                      </vs-td> -->
                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
            <!-- 清单保存按钮 -->
            <div class="order-push-cutline"></div>
            <div class="vs-row order-btn-right p-2">
              <vs-button class="order-btn-con" @click="inventryPushState">{{
                inventryPush
              }}</vs-button>
              <vs-button
                id="order-cancel2"
                type="border"
                class="order-btn-con"
                @click="closeinventryPush"
                style="margin-right: 0"
                >{{ inventryCancle }}</vs-button
              >
            </div>
          </vs-tab>

          <vs-tab label="运单">
            <div style="max-height: 40vh" class="overflow-y-auto">
              <div class="flex flex-wrap flex-row">
                <div class="p-2">
                  <span>系统唯一序号</span><br />
                  <vs-input
                    v-model="orderConfigObj.guid"
                    placeholder="guid"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>报送类型</span><br />
                  <vs-input
                    v-model="logisticsConfigObj.appType"
                    placeholder="appType"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>报送时间</span><br />
                  <vs-input
                    placeholder="appTime"
                    v-model="logisticsConfigObj.appTime"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>业务状态</span><br />
                  <vs-input
                    placeholder="appStatus"
                    v-model="logisticsConfigObj.appStatus"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>物流企业代码</span><br />
                  <vs-input
                    placeholder="logisticsCode"
                    v-model="logisticsConfigObj.logisticsCode"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>物流企业名称</span><br />
                  <vs-input
                    placeholder="logisticsName"
                    v-model="logisticsConfigObj.logisticsName"
                    :disabled="stoplogisticsPush"
                  />
                </div>

                <div class="p-2">
                  <span>物流运单编号</span><br />
                  <vs-input
                    placeholder="logisticsNo"
                    v-model="logisticsConfigObj.logisticsNo"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <!-- <div class="p-2">
                  <span>提运单号:</span><br />
                  <vs-input placeholder="billNo" />
                </div> -->
                <div class="p-2">
                  <span>订单编号</span><br />
                  <vs-input
                    placeholder="orderNo"
                    v-model="logisticsConfigObj.orderNo"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>运费</span><br />
                  <vs-input
                    placeholder="freight"
                    v-model="logisticsConfigObj.freight"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>保价费</span><br />
                  <vs-input
                    placeholder="insuredFee"
                    v-model="logisticsConfigObj.insuredFee"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>币制</span><br />
                  <vs-input
                    placeholder="currency"
                    v-model="logisticsConfigObj.currency"
                    :disabled="stoplogisticsPush"
                  />
                </div>

                <div class="p-2">
                  <span>毛重</span><br />
                  <vs-input
                    placeholder="weight"
                    v-model="logisticsConfigObj.weight"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>件数</span><br />
                  <vs-input
                    placeholder="packNo"
                    v-model="logisticsConfigObj.packNo"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <!-- <div class="p-2">
                  <span>主要货物信息:</span><br />
                  <vs-input placeholder="goodsInfo" />
                </div> -->
                <div class="p-2">
                  <span>收货人姓名</span><br />
                  <vs-input
                    placeholder="consignee"
                    v-model="logisticsConfigObj.consignee"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>收货人地址</span><br />
                  <vs-input
                    placeholder="consigneeAddress"
                    v-model="logisticsConfigObj.consigneeAddress"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <div class="p-2">
                  <span>收货人电话</span><br />
                  <vs-input
                    placeholder="consigneeTelephone"
                    v-model="logisticsConfigObj.consigneeTelephone"
                    :disabled="stoplogisticsPush"
                  />
                </div>
                <!-- <div class="p-2">
                  <span>guid:</span><br />
                  <vs-input
                    placeholder="guid"
                    v-model="logisticsConfigObj.guid"
                  />
                </div> -->
                <!-- <div class="p-2">
                  <span>报文传输模式:</span><br />
                  <vs-input
                    placeholder="dxpMode"
                    v-model="logisticsConfigObj.dxpMode"
                  />
                </div> -->
                <!-- <div class="p-2">
                  <span>收货人省:</span><br />
                  <vs-input
                    placeholder="consigneeProvince"
                    v-model="logisticsConfigObj.consigneeProvince"
                  />
                </div>
                <div class="p-2">
                  <span>收货人市:</span><br />
                  <vs-input
                    placeholder="consigneeCity"
                    v-model="logisticsConfigObj.consigneeCity"
                  />
                </div>
                <div class="p-2">
                  <span>收货人区:</span><br />
                  <vs-input
                    placeholder="consigneeDistrict"
                    v-model="logisticsConfigObj.consigneeDistrict"
                  />
                </div> -->
              </div>

              <div class="vs-row">
                <div class="vs-col sm:w-1/2 flex lg:flex-row md:flex-no-wrap">
                  <div class="p-2">
                    <span>传输企业名称</span><br />
                    <vs-input
                      placeholder="copName"
                      v-model="logisticsConfigObj.copName"
                      :disabled="stoplogisticsPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>传输企业代码</span><br />
                    <vs-input
                      placeholder="copCod"
                      v-model="logisticsConfigObj.copCode"
                      :disabled="stoplogisticsPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>报文传输编号</span><br />
                    <vs-input
                      placeholder="dxpId"
                      v-model="logisticsConfigObj.dxpId"
                      :disabled="stoplogisticsPush"
                    />
                  </div>
                  <div class="p-2">
                    <span>公服企业名称</span><br />
                    <vs-input
                      placeholder="keyInfo"
                      v-model="logisticsConfigObj.keyInfo"
                      :disabled="stoplogisticsPush"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 运单保存按钮 -->
            <div class="order-push-cutline"></div>
            <div class="vs-row order-btn-right p-2">
              <vs-button class="order-btn-con" @click="logisticsPushState">{{
                logisticsPush
              }}</vs-button>
              <vs-button
                id="order-cancel3"
                type="border"
                class="order-btn-con"
                @click="closelogisticsPush"
                style="margin-right: 0"
                >{{ logisticsCancle }}</vs-button
              >
            </div>
          </vs-tab>
        </vs-tabs>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import orderRepo from '@/repo/order'
import TheConfigGoodsTable from './TheConfigGoodsTable.vue'

export default {
  name: 'PushConfigDialog',
  components: {
    TheConfigGoodsTable,
  },
  props: ['passNum', 'activePrompt11'],
  data() {
    return {
      inventryGodsList: [],
      orderGodsList: [], //订单推单表数组
      index_id: '',
      active: false,
      appTime: '',
      orderConfigObj: {},
      logisticsConfigObj: {},
      inventoryConfigObj: {},
      orderPush: '编辑',
      stopOrderPush: true,
      orderCancle: '关闭',

      inventryPush: '编辑',
      inventryCancle: '关闭',
      stopinventryPush: true,

      logisticsPush: '编辑',
      logisticsCancle: '关闭',
      stoplogisticsPush: true,
    }
  },
  mounted() {},
  beforeUpdate() {},
  beforeDestroy() {
    console.log('销毁')
  },
  methods: {
    //订单推单页面
    orderPushState() {
      if (this.orderPush == '编辑') {
        this.orderPush = '保存'
        this.orderCancle = '取消'
        this.stopOrderPush = false
      } else if (this.orderPush == '保存') {
        // console.log(this.orderConfigObj)
        let that = this
        if (typeof that.orderConfigObj.buyerIdType == 'number') {
          that.orderConfigObj.buyerIdType = String(
            that.orderConfigObj.buyerIdType
          )
        }
        orderRepo.update_order_config(
          that.orderConfigObj,
          that.index_id,
          (error, data) => {
            if (data.code == 0) {
              that.openNotify(data.msg, 'success')
            } else {
              that.$vs.notify({
                position: 'bottom-center',
                color: '#ccc',
                title: '操作提示',
                text: data.msg,
              })
            }
          }
        )
        if (that.orderGodsList.length) {
          // console.log('订单表体内容', that.orderGodsList)
          let queue = []
          // function savelist(obj) {
          //   return new Promise((resolve, reject) => {
          //     let rowGoodsId = obj.id
          //     let pa = JSON.parse(JSON.stringify(obj))
          //     delete pa.id
          //     orderRepo.editOrderPushGoodsList(
          //       rowGoodsId,
          //       pa,
          //       (error, resp) => {
          //         if (resp.code == 0) {
          //           resolve(resp)
          //         } else {
          //           reject(error)
          //         }
          //       }
          //     )
          //   })
          // }
          for (let a = 0; a < that.orderGodsList.length; a++) {
            queue.push(that.saveOrderGodsList(that.orderGodsList[a]))
          }
          Promise.all(queue).then(
            (res) => {
              that.openNotify('修改成功', 'success')
            },
            (error) => {
              console.log(error)
              that.$vs.notify({
                position: 'bottom-center',
                color: 'danger',
                title: '操作提示',
                text: '修改失败',
              })
            }
          )

          // let rowGoodsId = that.orderGodsList[0].id
          // let pa = JSON.parse(JSON.stringify(that.orderGodsList[0]))
          // delete pa.id
          // orderRepo.editOrderPushGoodsList(rowGoodsId, pa, (error, resp) => {
          //   if (resp.code == 0) {
          //     that.openNotify(resp.msg, 'success')
          //   } else {
          //     that.$vs.notify({
          //       position: 'bottom-center',
          //       color: 'danger',
          //       title: '操作提示',
          //       text: resp.msg,
          //     })
          //   }
          // })
        }
        this.orderPush = '编辑'
        this.orderCancle = '关闭'
        this.stopOrderPush = true
      }
    },
    closeOrderPush() {
      if (this.orderCancle == '关闭') {
        this.active = false
      } else if (this.orderCancle == '取消') {
        let a = setTimeout(() => {
          let btn = document.getElementById('order-cancel1')
          btn.blur()
          clearTimeout(a)
        }, 100)
        this.stopOrderPush = true
        this.orderPush = '编辑'
        this.orderCancle = '关闭'
      }
    },
    //清单推单页面函数
    inventryPushState() {
      if (this.inventryPush == '编辑') {
        this.inventryPush = '保存'
        this.inventryCancle = '取消'
        this.stopinventryPush = false
      } else if (this.inventryPush == '保存') {
        // console.log(this.inventoryConfigObj)
        let that = this
        if (typeof that.inventoryConfigObj.buyerIdType == 'number') {
          that.inventoryConfigObj.buyerIdType = String(
            that.inventoryConfigObj.buyerIdType
          )
        }
        orderRepo.update_inventury_config(
          that.inventoryConfigObj,
          that.index_id,
          (error, resp) => {
            if (resp.code == 0) {
              that.openNotify(resp.msg, 'success')
            } else {
              that.$vs.notify({
                position: 'bottom-center',
                color: '#ccc',
                title: '操作提示',
                text: resp.msg,
              })
            }
          }
        )
        if (that.inventryGodsList.length) {
          let queue = []
          // function savelist(obj) {
          //   return new Promise((resolve, reject) => {
          //     let inventGoodsId = obj.id
          //     let pa = JSON.parse(JSON.stringify(obj))
          //     delete pa.id
          //     orderRepo.editInventuryPushGoodsList(
          //       inventGoodsId,
          //       pa,
          //       (error, resp) => {
          //         if (resp.code == 0) {
          //           resolve(resp)
          //         } else {
          //           reject(error)
          //         }
          //       }
          //     )
          //   })
          // }
          for (let a = 0; a < that.inventryGodsList.length; a++) {
            queue.push(that.saveInventryGodsList(that.inventryGodsList[a]))
          }
          Promise.all(queue).then(
            (res) => {
              that.openNotify('修改成功', 'success')
            },
            (error) => {
              console.log(error)
              that.$vs.notify({
                position: 'bottom-center',
                color: 'danger',
                title: '操作提示',
                text: '修改失败',
              })
            }
          )

          // let inventGoodsId = that.inventryGodsList[0].id
          // let pa = JSON.parse(JSON.stringify(that.inventryGodsList[0]))
          // // let pa = that.inventryGodsList[0]
          // delete pa.id
          // orderRepo.editInventuryPushGoodsList(
          //   inventGoodsId,
          //   pa,
          //   (error, resp) => {
          //     if (resp.code == 0) {
          //       that.openNotify(resp.msg, 'success')
          //     } else {
          //       that.$vs.notify({
          //         position: 'bottom-center',
          //         color: 'danger',
          //         title: '操作提示',
          //         text: resp.msg,
          //       })
          //     }
          //   }
          // )
        }
        this.inventryPush = '编辑'
        this.inventryCancle = '关闭'
        this.stopinventryPush = true
      }
    },
    closeinventryPush() {
      if (this.inventryCancle == '关闭') {
        this.active = false
      } else if (this.inventryCancle == '取消') {
        let a = setTimeout(() => {
          let btn = document.getElementById('order-cancel2')
          btn.blur()
          clearTimeout(a)
        }, 100)
        this.stopinventryPush = true
        this.inventryPush = '编辑'
        this.inventryCancle = '关闭'
      }
    },
    // 运单页面函数
    logisticsPushState() {
      if (this.logisticsPush == '编辑') {
        this.logisticsPush = '保存'
        this.logisticsCancle = '取消'
        this.stoplogisticsPush = false
      } else if (this.logisticsPush == '保存') {
        // console.log(this.logisticsConfigObj)
        let that = this
        orderRepo.update_logistic_config(
          that.logisticsConfigObj,
          that.index_id,
          (error, resp) => {
            console.log(error,resp)
            if (resp.code == 0) {
              that.openNotify(resp.msg, 'success')
            } else {
              that.$vs.notify({
                position: 'bottom-center',
                color: '#ccc',
                title: '操作提示',
                text: resp.msg,
              })
            }
          }
        )
        this.logisticsPush = '编辑'
        this.logisticsCancle = '关闭'
        this.stoplogisticsPush = true
      }
    },
    closelogisticsPush() {
      if (this.logisticsCancle == '关闭') {
        this.active = false
      } else if (this.logisticsCancle == '取消') {
        let a = setTimeout(() => {
          let btn = document.getElementById('order-cancel3')
          btn.blur()
          clearTimeout(a)
        }, 100)
        this.stoplogisticsPush = true
        this.logisticsPush = '编辑'
        this.logisticsCancle = '关闭'
      }
    },
    /**
     * @description get接口
     */
    fetch: function (id) {
      this.index_id = id
      this.$vs.loading()
      let that = this
      orderRepo.order_config(id, (error, resp) => {
        that.$vs.loading.close()
        if (resp.code === 0 && resp.data.constructor === Object) {
          console.log('订单推单', resp.data)
          resp.data.appType = String(resp.data.appType)
          resp.data.appStatus = String(resp.data.appStatus)
          resp.data.currency = String(resp.data.currency)
          resp.data.buyerIdType = String(resp.data.buyerIdType)
          that.orderConfigObj = JSON.parse(JSON.stringify(resp.data))
        }
      })

      orderRepo.inventory_config(id, (error, resp) => {
        if (resp.code === 0 && resp.data.constructor === Object) {
          console.log('清单推单', resp.data)
          for (const key in resp.data) {
            if (resp.data[key] !== null) {
              resp.data[key] = String(resp.data[key])
            }
          }
          that.inventoryConfigObj = JSON.parse(JSON.stringify(resp.data))
          // console.log("清单推单",that.inventoryConfigObj)
        }
      })

      orderRepo.logistics_config(id, (error, resp) => {
        if (resp.code === 0 && resp.data.constructor === Object) {
          console.log('运单推单', resp.data)
          for (const key in resp.data) {
            if (resp.data[key] !== null) {
              resp.data[key] = String(resp.data[key])
            }
          }
          that.logisticsConfigObj = JSON.parse(JSON.stringify(resp.data))
          // console.log("运单推单",that.logisticsConfigObj)
        }
      })

      orderRepo.getOrderPushGoodsList(id, (error, resp) => {
        if (resp.code == 0) {
          // console.log('订单列表', resp.data)
          if (Array.isArray(resp.data)) {
            resp.data.forEach((v) => {
              v.currency = String(v.currency)
              v.count = String(v.count)
              v.gnum = String(v.gnum)
            })
            that.orderGodsList = JSON.parse(JSON.stringify(resp.data))
            // console.log("运单表单",that.orderGodsList)
          }
        } else {
          that.openNotify('获取订单推单信息表数据失败')
        }
      })

      orderRepo.getInventuryPushGoodsList(id, (error, resp) => {
        if (resp.code == 0) {
          // console.log('清单列表', resp.data)
          if (Array.isArray(resp.data)) {
            resp.data.forEach((v) => {
              v.count = String(v.count)
              v.gnum = String(v.gnum)
              v.currency = String(v.currency)
            })
            that.inventryGodsList = JSON.parse(JSON.stringify(resp.data))
            // console.log("清单表单2",that.inventryGodsList)
          }
        } else {
          that.openNotify('获取运单推单信息表数据失败')
        }
      })
    },

    close11: function () {
      this.orderConfigObj = {}
      this.logisticsConfigObj = {}
      this.inventoryConfigObj = {}
      // this.$refs.goodasConfig.cancelPrompt()
      this.inventryGodsList = []
      this.active = false
    },

    openDialog: function (rowId) {
      // console.log(window.innerWidth)
      // console.log(window.innerHeight)
      this.inventryGodsList = []
      this.orderGodsList = []
      this.orderConfigObj = {}
      this.logisticsConfigObj = {}
      this.inventoryConfigObj = {}
      this.active = true
      this.fetch(rowId)
      this.orderPush = '编辑'
      this.orderCancle = '关闭'
      this.stopOrderPush = true
      this.inventryPush = '编辑'
      this.inventryCancle = '关闭'
      this.stopinventryPush = true
      this.logisticsPush = '编辑'
      this.logisticsCancle = '关闭'
      this.stoplogisticsPush = true
    },

    /**
     * @description 接口提示回显toast
     */
    openNotify: function (msg, color = 'danger') {
      this.$vs.notify({
        position: 'bottom-center',
        color: color,
        title: '操作提示',
        text: msg,
      })
    },
    saveOrderGodsList(obj) {
      return new Promise((resolve, reject) => {
        let rowGoodsId = obj.id
        let pa = JSON.parse(JSON.stringify(obj))
        delete pa.id
        orderRepo.editOrderPushGoodsList(rowGoodsId, pa, (error, resp) => {
          if (resp.code == 0) {
            resolve(resp)
          } else {
            reject(error)
          }
        })
      })
    },
    saveInventryGodsList(obj) {
      return new Promise((resolve, reject) => {
        let inventGoodsId = obj.id
        let pa = JSON.parse(JSON.stringify(obj))
        delete pa.id
        orderRepo.editInventuryPushGoodsList(
          inventGoodsId,
          pa,
          (error, resp) => {
            if (resp.code == 0) {
              resolve(resp)
            } else {
              reject(error)
            }
          }
        )
      })
    },
  },
}
</script>


<style lang="scss">
.order_goods_push_table thead .vs-table-text {
  white-space: nowrap !important;
}

// .inner_push_config_dialog .o_v_auto_rem29 {
//   max-height: 60vh;
//   @media (max-height: 700px) {
//     max-height: 60vh;
//     overflow:auto;
//   }
//   @media (min-height: 830px) {
//     max-height: 72vh;
//     overflow:auto;
//   }
// }
.inner_push_config_dialog .inventry_goods_push_div {
  max-height: 60vh;
  overflow: auto;
}
.inner_push_config_dialog .inventry_goods_push_div thead .vs-table-text {
  white-space: nowrap !important;
}
.td-push-input {
  border-radius: 5px;
  height: 30px;
  width: 100%;
  border: 1px solid #f8f8f8;
  text-decoration: underline;
  color: #626262;
  &:hover {
    cursor: pointer;
    background-color: white;
    border: 1px solid #7367f0;
    transition: all;
    transition-duration: 0.5s;
    transition-timing-function: ease-in-out;
  }
  background-color: #f8f8f8;
}

.order-btn-right {
  display: flex;
  justify-content: flex-end;
  margin-bottom: -1rem;
}
.order-btn-con {
  margin-right: 15px;
}
.order-push-cutline {
  margin-top: 20px;
  margin-bottom: 10px;
  margin-left: auto;
  margin-right: auto;
  width: 98%;
  height: 0;
  border: 1px solid #f2f2f2;
  border-width: 1px 0 0 0;
}

@media (max-height: 550px) {
  .inner_push_config_dialog .o_v_auto_rem29 {
    max-height: 40vh;
    overflow: auto;
  }
  .inner_push_config_dialog .inventry_goods_push_div {
    max-height: 40vh;
    overflow: auto;
  }
}
@media (min-height: 550px) {
  .inner_push_config_dialog .o_v_auto_rem29 {
    max-height: 60vh;
    overflow: auto;
  }
  .inner_push_config_dialog .inventry_goods_push_div {
    max-height: 60vh;
    overflow: auto;
  }
}
@media (min-height: 700px) {
  .inner_push_config_dialog .o_v_auto_rem29 {
    max-height: 65vh;
    overflow: auto;
  }
  .inner_push_config_dialog .inventry_goods_push_div {
    max-height: 65vh;
    overflow: auto;
  }
}
@media (min-height: 830px) {
  .inner_push_config_dialog .o_v_auto_rem29 {
    max-height: 72vh;
    overflow: auto;
  }
  .inner_push_config_dialog .inventry_goods_push_div {
    max-height: 70vh;
    overflow: auto;
  }
}
</style>
